<template>
  <b-modal class="modal-lg" id="deleteAllModal" ref="delete-all-modal" :title="deleteAllModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'trash']" size="1x" class="mr-2"/> {{ deleteAllModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <h5 class="text-center text-muted">{{ t('manageBatchesDeleteAllText','manageBatchesDeleteAllText') }}</h5>
      <transition name="fade">
        <ResponseInfo v-if="(getResponseInfo.name == 'DeleteAllTestBatches') && (getResponseInfo.status == 'error')" class="mt-3"/>
      </transition>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <div class="d-flex flex-column w-100">
        <div class="d-flex justify-content-end align-items-center">
          <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()"><fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelButtonText', 'cancelButtonText')}}</button>
          <div v-if="buttonIsBusy" style="width:80px;">
            <div class="sk-folding-cube">
              <div class="sk-cube1 sk-cube"></div>
              <div class="sk-cube2 sk-cube"></div>
              <div class="sk-cube4 sk-cube"></div>
              <div class="sk-cube3 sk-cube"></div>
            </div>
          </div>
          <button v-if="!buttonIsBusy" aria-label="Delete" data-dismiss="modal" class="btn btn-danger mx-2" type="button" @click="deleteAllTestBatches()"><fontAwesomeIcon :icon="['fa', 'trash']" class="text-light mr-2"/> {{ t('deleteButtonText', 'deleteButtonText')}}</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalDeleteAllTestBatches',
  //this component inherits from the ManageBatches.vue component
  inject: [
    'resetModal',
    'requestBatches'
  ],
  data () {
    return {
      deleteAllModal: {},
      buttonIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    deleteAllTestBatches() {
      this.buttonIsBusy = true
      this.$store.dispatch('deleteAllTestBatches')
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$parent.requestBatches()
          this.$refs['delete-all-modal'].hide()
        }
      })
    }
  },
  created() {
    this.deleteAllModal = this.$attrs.modal
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
</style>
